import React, { Suspense, lazy } from "react"
import { useSelector } from "react-redux"
import { HOC as Permissions } from "react-redux-permissions"
import { Navigate, Route, Routes } from "react-router-dom"

import Loader from "shared/components/Loader/Local"
import ModuleDisabled from "shared/views/NotAllowed/ModuleDisabled"
import ModuleNotAvailable from "shared/views/NotAllowed/ModuleNotAvailable"

const ListingRules = lazy(() => import("./ListingRules"))
const TranslationSettings = lazy(() => import("./TranslationSettings"))
const PriceManagement = lazy(() => import("./PriceManagement"))
const ShippingSettings = lazy(() => import("./ShippingSettings"))

const PriceManagementView = Permissions(["ebay", "amazon"], ["preTrialESB"])(
  PriceManagement,
  <ModuleDisabled
    className={["m-t-30", "m-b-30"].join(" ")}
    view="Price Management"
  />
)

const ShippingSettingsView = Permissions(["ebay"])(
  ShippingSettings,
  <ModuleDisabled
    className={["m-t-30", "m-b-30"].join(" ")}
    view="Shipping Settings"
  />
)

export default function InternationalizationSettings() {
  const { activePlatform } = useSelector(state => state.general)
  return (
    <Routes>
      <Route path="/">
        <Route index element={<Navigate to="listing-rules" replace />} />
        <Route
          path="listing-rules/*"
          element={
            <Suspense fallback={<Loader floating={false} />}>
              <ListingRules />
            </Suspense>
          }
        />
        <Route
          path="translation-settings/*"
          element={
            <Suspense fallback={<Loader floating={false} />}>
              <TranslationSettings />
            </Suspense>
          }
        />
        <Route
          path="price-management/*"
          element={
            <Suspense fallback={<Loader floating={false} />}>
              <PriceManagementView />
            </Suspense>
          }
        />
        <Route
          path="shipping-settings/*"
          element={
            <Suspense fallback={<Loader floating={false} />}>
              {activePlatform === "ebay" ? (
                <ShippingSettingsView />
              ) : (
                <ModuleNotAvailable
                  className={["m-t-30", "m-b-30"].join(" ")}
                  view="Shipping Settings"
                />
              )}
            </Suspense>
          }
        />
      </Route>
    </Routes>
  )
}
